// DashboardSummaryWidget.jsx
import React, { useMemo } from "react";
import { useAgentDashboardMetrics } from "@/hooks";
import { thousandSeperatedValue } from "@/helpers/v2/common";
import dashboardMoneySvg from "@/images/dashboard-money.svg";
import dashboardBuildingsSvg from "@/images/dashboard-buildings.svg";
import dashboardWantListingSvg from "@/images/dashboard-wantlisting.svg";
import dashboardTimeSvg from "@/images/dashboard-time.svg";
import dashboardWalletSvg from "@/images/dashboard-wallet.svg";

const DashboardSummaryWidget = ({ scope = "inventory" }) => {
  const { data, loading } = useAgentDashboardMetrics(scope);

  const items = useMemo(() => {
    if (loading)
      return scope === "inventory" ? Array(3).fill({}) : Array(4).fill({});

    if (!data) return [];

    if (scope === "inventory")
      return [
        {
          title: "Potential Seller Home Values",
          value:
            data.potentialSellerValue != null
              ? `$${Number(data.potentialSellerValue).toLocaleString("en-US", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}`
              : "-",
          img: dashboardMoneySvg,
        },
        {
          title: "Total Buyer Matches",
          value: thousandSeperatedValue(data.totalBuyerMatches) ?? "-",
          img: dashboardBuildingsSvg,
        },
        {
          title: "Active Listing Matches",
          value: thousandSeperatedValue(data.activeListingBuyerMatches) ?? "-",
          img: dashboardWalletSvg,
        },
      ];

    return [
      {
        title: "Active Buyer Pipeline",
        value:
          data.activeBuyerPipeline != null
            ? `$${Number(data.activeBuyerPipeline).toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}`
            : "-",
        img: dashboardMoneySvg,
      },
      {
        title: "Active Want Listings",
        value: data.currentWantListings ?? "-",
        img: dashboardWantListingSvg,
      },
      {
        title: "Forms Waiting Review",
        value: data.formsWaitingReview ?? "-",
        img: dashboardTimeSvg,
      },
      {
        title: "Property Matches",
        value: thousandSeperatedValue(data.propertyMatches) ?? "-",
        img: dashboardWalletSvg,
      },
    ];
  }, [loading, data, scope]);

  return (
    <div className="dashboard-summary-widget d-flex justify-content-between align-items-center p-4">
      {items.map(({ title, value, img }, index) => (
        <div
          key={title || index}
          className="summary-item d-flex align-items-center flex-grow-1"
        >
          <div className="me-3">
            {loading ? (
              <div className="dashboard-placeholder-circle" />
            ) : (
              <img src={img} className="dashboard-figma-icon" alt="" />
            )}
          </div>
          <div className="text-wrapper w-100">
            <h6 className="mb-1 dashboard-text-secondary">
              {loading ? (
                <div className="dashboard-placeholder-line w-75" />
              ) : (
                title
              )}
            </h6>
            <h3 className="mb-1 dashboard-text-tertiary">
              {loading ? (
                <div className="dashboard-placeholder-line w-50" />
              ) : (
                value
              )}
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardSummaryWidget;
